class LkpAccountPopover extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('[data-account-popover-trigger]');
    this.panel = this.querySelector('[data-account-popover-panel]');
    this.focusableSelectors = 'a, button, [tabindex]:not([tabindex="-1"])';
    this.boundOutside = this.handleOutsideClick.bind(this);
    this.boundEscape = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    if (!this.trigger || !this.panel) return;
    this.trigger.addEventListener('click', () => this.toggle());
    this.trigger.addEventListener('keydown', (event) => this.onTriggerKeydown(event));
    this.panel.addEventListener('keydown', this.boundEscape);
  }

  disconnectedCallback() {
    this.removeDocumentListeners();
  }

  toggle(force) {
    const shouldOpen = typeof force === 'boolean' ? force : this.panel.hidden;
    if (shouldOpen) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.panel.hidden = false;
    this.trigger.setAttribute('aria-expanded', 'true');
    document.addEventListener('mousedown', this.boundOutside, { capture: true });
    document.addEventListener('touchstart', this.boundOutside, { capture: true });
    document.addEventListener('keydown', this.boundEscape);
    this.focusFirstItem();
  }

  close() {
    this.panel.hidden = true;
    this.trigger.setAttribute('aria-expanded', 'false');
    this.removeDocumentListeners();
  }

  removeDocumentListeners() {
    document.removeEventListener('mousedown', this.boundOutside, { capture: true });
    document.removeEventListener('touchstart', this.boundOutside, { capture: true });
    document.removeEventListener('keydown', this.boundEscape);
  }

  handleOutsideClick(event) {
    if (!this.contains(event.target)) {
      this.close();
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
      this.trigger.focus();
    } else if (event.key === 'Tab') {
      this.trapFocus(event);
    }
  }

  onTriggerKeydown(event) {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.open();
    }
  }

  trapFocus(event) {
    const focusables = Array.from(this.panel.querySelectorAll(this.focusableSelectors)).filter((el) => !el.hasAttribute('disabled'));
    if (focusables.length === 0) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  focusFirstItem() {
    const firstItem = this.panel.querySelector(this.focusableSelectors);
    if (firstItem) firstItem.focus({ preventScroll: true });
  }
}

customElements.define('lkp-account-popover', LkpAccountPopover);
